import React, { useEffect, useState } from 'react';
import { Building2, Save } from 'lucide-react';
import api from '../services/api';
import { PageHeader } from '../components/PageParts';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { toast } from 'sonner';
import { BRAZIL_STATES, BRAND } from '../utils/constants';

export default function Company() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/company').then(r => setData(r.data)).catch(() => toast.error('Erro ao carregar empresa'));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data: updated } = await api.put('/company', data);
      setData(updated);
      toast.success('Dados da empresa salvos');
    } catch { toast.error('Erro ao salvar'); } finally { setSaving(false); }
  };

  if (!data) return <div className="space-y-3">{Array.from({ length: 6 }).map((_, i) => <div key={i} className="h-12 rounded-lg shimmer" />)}</div>;

  return (
    <div>
      <PageHeader title="Configurações da Empresa" subtitle="Dados cadastrais e informações de contato" />
      <form onSubmit={submit} className="space-y-6">
        {/* Logo card */}
        <div className="rounded-xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 p-6 flex items-center gap-5">
          <div className="h-24 w-24 rounded-xl border-2 border-dashed border-neutral-300 dark:border-neutral-700 flex items-center justify-center bg-neutral-50 dark:bg-neutral-950 overflow-hidden">
            <img src={data.logo_url || BRAND.logoUrl} alt="Logo" className="h-full w-full object-contain" />
          </div>
          <div className="flex-1">
            <p className="font-semibold">Logo da empresa</p>
            <p className="text-xs text-neutral-500 mt-1">URL da imagem para exibição no sistema.</p>
            <Input className="mt-2 max-w-xl" placeholder="https://..." value={data.logo_url || ''} onChange={(e) => setData({ ...data, logo_url: e.target.value })} />
          </div>
        </div>

        <div className="rounded-xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 p-6">
          <div className="flex items-center gap-2 mb-4">
            <Building2 className="h-5 w-5 text-brand" />
            <h3 className="font-semibold">Dados cadastrais</h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-1.5 md:col-span-2"><Label>Razão Social</Label><Input value={data.corporate_name || ''} onChange={(e) => setData({ ...data, corporate_name: e.target.value })} /></div>
            <div className="space-y-1.5"><Label>Nome Fantasia</Label><Input value={data.trade_name || ''} onChange={(e) => setData({ ...data, trade_name: e.target.value })} /></div>
            <div className="space-y-1.5"><Label>CNPJ</Label><Input value={data.cnpj || ''} onChange={(e) => setData({ ...data, cnpj: e.target.value })} /></div>
            <div className="space-y-1.5"><Label>Inscrição Estadual</Label><Input value={data.ie || ''} onChange={(e) => setData({ ...data, ie: e.target.value })} /></div>
            <div className="space-y-1.5"><Label>Telefone</Label><Input value={data.phone || ''} onChange={(e) => setData({ ...data, phone: e.target.value })} /></div>
            <div className="space-y-1.5"><Label>Email</Label><Input type="email" value={data.email || ''} onChange={(e) => setData({ ...data, email: e.target.value })} /></div>
            <div className="space-y-1.5"><Label>CEP</Label><Input value={data.zip_code || ''} onChange={(e) => setData({ ...data, zip_code: e.target.value })} /></div>
            <div className="space-y-1.5 md:col-span-2"><Label>Endereço</Label><Input value={data.address || ''} onChange={(e) => setData({ ...data, address: e.target.value })} /></div>
            <div className="space-y-1.5"><Label>Cidade</Label><Input value={data.city || ''} onChange={(e) => setData({ ...data, city: e.target.value })} /></div>
            <div className="space-y-1.5">
              <Label>UF</Label>
              <Select value={data.state || ''} onValueChange={(v) => setData({ ...data, state: v })}>
                <SelectTrigger><SelectValue placeholder="Selecione" /></SelectTrigger>
                <SelectContent>{BRAZIL_STATES.map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
              </Select>
            </div>
          </div>
        </div>

        <div className="flex justify-end">
          <Button type="submit" disabled={saving} className="bg-brand hover:bg-[#A81E23] text-white">
            <Save className="h-4 w-4 mr-2" />{saving ? 'Salvando...' : 'Salvar alterações'}
          </Button>
        </div>
      </form>
    </div>
  );
}
